import { TableRow, Typography } from "@mui/material";
import { TableCellBody } from "@src/components";
import React from "react";
import {
  PopularProductModel,
  ProductsModel,
} from "../../../domain/models/PopularProductModel";

interface TopPositionsTableBodyDateProps {
  position: ProductsModel;
}

export const TopPositionsTableBodyData: React.FC<
  TopPositionsTableBodyDateProps
> = (props) => {
  const { position } = props;

  return (
    <>
      <TableRow
        style={{
          verticalAlign: "center",
          borderTop: "1px solid #E5E5E5",
        }}
      >
        <TableCellBody width={"15%"}>
          <Typography fontSize={"20px"}>{position.rank}</Typography>
        </TableCellBody>
        <TableCellBody width={"35%"}>
          <Typography fontSize={"20px"}>{position.productName}</Typography>
        </TableCellBody>
        <TableCellBody width={"15%"}>
          <Typography fontSize={"20px"}>{position.totalOrders}</Typography>
        </TableCellBody>
        <TableCellBody width={"15%"}>
          <Typography fontSize={"20px"}>{position.totalSales}</Typography>
        </TableCellBody>
      </TableRow>
    </>
  );
};